module.exports = __webpack_public_path__ + "static/media/fly0003.2e163014.webp";